module.exports = __webpack_public_path__ + "static/scen-4-9bcb2cc391fcf03bd51ddc366718c340.svg";